import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { GlobalMessageService, I18nModule } from '@spartacus/core'
import { IconModule, ItemCounterModule, OutletModule } from '@spartacus/storefront'
import { RecaptchaModule } from 'ng-recaptcha'
import { NgxFileDropModule } from 'ngx-file-drop'
import { EbDatalistModule } from '../../components/datalist/eb-datalist.module'
import { EbGenericPageStepperModule } from '../../components/generic-page-stepper/eb-generic-page-stepper.module'
import {EbItemCounterModule} from "../cart/components/item-counter/eb-item-counter.module";
import { EbFormComponent } from './components/form/eb-form.component'
import { EbFormFieldComponent } from './components/form-field/eb-form-field.component'
import { EbFormValidatorProviderService } from './services/eb-validator-provider.service'

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    EbGenericPageStepperModule,
    ReactiveFormsModule,
    IconModule,
    ItemCounterModule,
    RecaptchaModule,
    OutletModule,
    NgxFileDropModule,
    EbDatalistModule,
    EbItemCounterModule
  ],
  declarations: [EbFormComponent, EbFormFieldComponent],
  exports: [EbFormComponent],
  providers: [EbFormValidatorProviderService, GlobalMessageService]
})
export class EbFormModule {}
